import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface CertificationActionRowProps {
  icon: ReactNode;
  iconBgColor: string;
  label: string;
  onClick: () => void;
  loading?: boolean;
}

const CertificationActionRow: FC<CertificationActionRowProps> = ({
  icon,
  iconBgColor,
  label,
  onClick,
  loading = false,
}) => (
  <Stack
    direction="row"
    alignItems="center"
    role="button"
    tabIndex={0}
    aria-label={label}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        onClick();
      }
    }}
    sx={{ px: 2, py: 1.5, gap: 1.5, cursor: 'pointer' }}
  >
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: '10px',
        backgroundColor: iconBgColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
    <Typography sx={{ fontSize: 14, fontWeight: 500, flexGrow: 1 }}>
      {label}
    </Typography>
    {loading ? (
      <CircularProgress size={16} />
    ) : (
      <ChevronRightIcon sx={{ fontSize: 18, color: 'grey.400' }} />
    )}
  </Stack>
);

export default CertificationActionRow;
